
// Constants
import { APP_CONFIG } from "../constants";


export const StorageService = {

    save: (key, value) => {

        localStorage.setItem(key, JSON.stringify(value) );
    },

    load: (key) => {

        return JSON.parse(localStorage.getItem(key));
    },

    /**
     * Obtiene del storage el primer elemento que coincida con la partKey
     * @param {*} partKey
     */
    loadByPartKey: (partKey) => {

        const key = Object.keys(localStorage).find(key => key.indexOf(partKey) >= 0);

        return JSON.parse(localStorage.getItem(key));
    },

    delete: ( key ) => {

        localStorage.removeItem(key);
    },

    clear: () => {

        const version = StorageService.load(APP_CONFIG.STORAGE.KEYS.VERSION) || '';
        localStorage.clear();

        if ( version !== '') {
            StorageService.save(APP_CONFIG.STORAGE.KEYS.VERSION, version);
        }
    }

};